import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e404e39"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "button-wrap"
}
const _hoisted_2 = { class: "select-list" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CallInfo = _resolveComponent("CallInfo")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DropdownList = _resolveComponent("DropdownList")!

  return (!_ctx.settings.minimize)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["active-call", {'active-call-max': _ctx.settings.maximize, 'active-call-min': !_ctx.settings.maximize}])
      }, [
        _createVNode(_component_CallInfo, {
          callData: _ctx.selectCall,
          "active-call": true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCallState(_ctx.selectCall.id)))
        }, null, 8, ["callData"]),
        (!_ctx.settings.maximize)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.calls.length - 1)
                ? (_openBlock(), _createBlock(_component_Typography, {
                    key: 0,
                    class: "calls-text",
                    fontColor: "--sui-gray-800"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`${_ctx.t('callInfo')} ${_ctx.calls.length - 1}`), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                class: "button-select",
                mode: "secondary",
                ref: "select",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    class: _normalizeClass(["icon", {'transform': _ctx.isOpen}]),
                    name: "ic20-chevron-down",
                    color: "--sui-gray-900"
                  }, null, 8, ["class"])
                ]),
                _: 1
              }, 512),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.isOpen)
                    ? (_openBlock(), _createBlock(_component_DropdownList, {
                        key: 0,
                        class: "call-active-list"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calls, (item, key) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "list-item",
                                onClick: ($event: any) => (_ctx.setSelectCall(item.id)),
                                key: key
                              }, [
                                _createVNode(_component_CallInfo, { callData: item }, null, 8, ["callData"])
                              ], 8, _hoisted_3))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}